import { render, staticRenderFns } from "./ParkingInformation.vue?vue&type=template&id=55da153a&scoped=true"
import script from "./ParkingInformation.vue?vue&type=script&lang=js"
export * from "./ParkingInformation.vue?vue&type=script&lang=js"
import style0 from "./ParkingInformation.vue?vue&type=style&index=0&id=55da153a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55da153a",
  null
  
)

export default component.exports